"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _auth = require("@modules/auth");

var _state = _interopRequireDefault(require("./state"));

var _actions = require("./actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _state.default;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.FETCH_DELIVERY_SERVICES_SUCCESS:
      return _objectSpread({}, state, {
        delivery: _objectSpread({}, state.delivery, {
          services: action.services
        })
      });

    case _actions.FETCH_DELIVERY_SERVICES_FAIL:
      return _objectSpread({}, state, {
        delivery: {
          services: []
        }
      });

    case _actions.FETCH_RECOMMENDATIONS_SUCCESS:
      return _objectSpread({}, state, {
        recommendations: action.recommendations
      });

    case _actions.POST_PAYMENT_SUCCESS:
      return _objectSpread({}, state, {
        thanks: _objectSpread({}, state.thanks, {
          address: action.order.address,
          deliveryDate: action.order.deliveryDate,
          deliveryEnd: action.order.deliveryEnd,
          deliveryStart: action.order.deliveryStart,
          id: action.order.id,
          products: action.order.products,
          total: action.order.total,
          totalShipping: action.order.totalShipping
        })
      });

    case _actions.PURGE_THANKS:
      return _objectSpread({}, state, {
        thanks: _state.default.thanks
      });

    case _auth.authActions.PURGE_ALL:
      return _state.default;

    default:
      return state;
  }
};

exports.default = _default;